// src/features/auth/signup/PasswordField.jsx
import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const PasswordField = ({ register, errors }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div>
            <label htmlFor="password" className="block text-sm font-medium text-surface-600 dark:text-surface-400 mb-1.5">
                Contraseña
            </label>
            <div className="relative">
                <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    autoComplete="new-password"
                    className="input-field pr-11"
                    {...register('password', {
                        required: 'La contraseña es obligatoria',
                        minLength: { value: 8, message: 'Debe tener al menos 8 caracteres' },
                        pattern: {
                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                            message: 'Debe incluir al menos una letra mayúscula, una letra minúscula, un número y un carácter especial (!, @, #, etc.)',
                        },
                    })}
                />
                <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute inset-y-0 right-0 px-3 text-surface-500 hover:text-surface-700 dark:hover:text-surface-300 transition-colors"
                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                >
                    {showPassword ? <FiEyeOff className="w-4 h-4" /> : <FiEye className="w-4 h-4" />}
                </button>
            </div>
            {errors.password && <span className="text-red-500 text-xs mt-1 block">{errors.password.message}</span>}
        </div>
    );
};

export default PasswordField;
